import { h } from 'preact';

const Footer = () => (
	<footer class="footer">
		<div class="content has-text-centered">
			<p>
				Email the sandymonster at <a href="mailto:hi@sandymonster.com">hi@sandymonster.com</a>.
			</p>
			<p>
				The <strong>SandyMonster</strong> website is created with &#10084; by <a href="https://retroit.nl">Retro IT</a>.
			</p>
		</div>
	</footer>
);

export default Footer;



// WEBPACK FOOTER //
// ./components/footer/index.js